// ==================== UI MESSAGES CONSTANTS ====================

export const MESSAGES = {
  // Success Messages
  SUCCESS: {
    LOGIN: 'Welcome back! You have successfully logged in.',
    REGISTER: 'Account created successfully! Please verify your email.',
    LOGOUT: 'You have been successfully logged out.',
    EMAIL_VERIFIED: 'Email verified successfully! You can now login.',
    PASSWORD_RESET: 'Password reset successfully! You can now login with your new password.',
    PASSWORD_RESET_EMAIL: 'Password reset instructions sent to your email.',
    PROFILE_UPDATED: 'Profile updated successfully.',
    SETTINGS_SAVED: 'Settings saved successfully.',
    CONTACT_CREATED: 'Contact created successfully.',
    CONTACT_UPDATED: 'Contact updated successfully.',
    CONTACT_DELETED: 'Contact deleted successfully.',
    CAMPAIGN_CREATED: 'Campaign created successfully.',
    CAMPAIGN_UPDATED: 'Campaign updated successfully.',
    CAMPAIGN_DELETED: 'Campaign deleted successfully.',
    TEMPLATE_CREATED: 'Template created successfully.',
    TEMPLATE_UPDATED: 'Template updated successfully.',
    TEMPLATE_DELETED: 'Template deleted successfully.',
    MESSAGE_SENT: 'Message sent successfully.',
    SUBSCRIPTION_UPDATED: 'Subscription updated successfully.',
    WHATSAPP_CONNECTED: 'WhatsApp Business account connected successfully.',
  },
  
  // Error Messages
  ERROR: {
    GENERIC: 'Something went wrong. Please try again later.',
    NETWORK: 'Network error. Please check your connection.',
    UNAUTHORIZED: 'You are not authorized to perform this action.',
    SESSION_EXPIRED: 'Your session has expired. Please login again.',
    INVALID_CREDENTIALS: 'Invalid email or password.',
    EMAIL_NOT_VERIFIED: 'Please verify your email before logging in.',
    EMAIL_ALREADY_EXISTS: 'An account with this email already exists.',
    INVALID_OTP: 'Invalid or expired verification code.',
    PASSWORD_MISMATCH: 'Passwords do not match.',
    WEAK_PASSWORD: 'Password must be at least 8 characters with uppercase, lowercase, number and special character.',
    INVALID_EMAIL: 'Please enter a valid email address.',
    REQUIRED_FIELD: 'This field is required.',
    FILE_TOO_LARGE: 'File size exceeds the maximum limit.',
    INVALID_FILE_TYPE: 'Invalid file type.',
    NOT_FOUND: 'The requested resource was not found.',
    SUBSCRIPTION_REQUIRED: 'An active subscription is required for this feature.',
    LIMIT_REACHED: 'You have reached the limit for this feature.',
  },
  
  // Confirmation Messages
  CONFIRM: {
    DELETE: 'Are you sure you want to delete this? This action cannot be undone.',
    LOGOUT: 'Are you sure you want to logout?',
    CANCEL_SUBSCRIPTION: 'Are you sure you want to cancel your subscription?',
    DISCONNECT_WHATSAPP: 'Are you sure you want to disconnect your WhatsApp Business account?',
  },
  
  // Info Messages
  INFO: {
    LOADING: 'Loading...',
    SAVING: 'Saving...',
    PROCESSING: 'Processing...',
    NO_DATA: 'No data available.',
    NO_RESULTS: 'No results found.',
    EMPTY_LIST: 'The list is empty.',
    COMING_SOON: 'This feature is coming soon.',
  },
  
  // Validation Messages
  VALIDATION: {
    EMAIL_REQUIRED: 'Email is required.',
    EMAIL_INVALID: 'Please enter a valid email address.',
    PASSWORD_REQUIRED: 'Password is required.',
    PASSWORD_MIN_LENGTH: 'Password must be at least 8 characters.',
    NAME_REQUIRED: 'Name is required.',
    PHONE_INVALID: 'Please enter a valid phone number.',
    FIELD_REQUIRED: 'This field is required.',
    TERMS_REQUIRED: 'You must accept the terms and conditions.',
  },
} as const;

